import { getApp, getApps, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyByWjU7ix-KjRQBewBRYyuNH1nEthBJark",
  authDomain: "basketapp-6b361.firebaseapp.com",
  databaseURL: "https://basketapp-6b361-default-rtdb.firebaseio.com",
  projectId: "basketapp-6b361",
  storageBucket: "basketapp-6b361.appspot.com",
  messagingSenderId: "920614814835",
  appId: "1:920614814835:web:f102ddc02233ae20ee9606",
};

const app = getApps.length > 0 ? getApp() : initializeApp(firebaseConfig);

const firestore = getFirestore(app);
const storage = getStorage(app);

export { app, firestore, storage };
